import { LinkType, VaccinationItemsType, VaccinationType } from "@types";

export enum SortTypes {
  favorite = "favorite",
  asc = "asc",
}

export const sortData = {
  favorite: "인기순",
  asc: "가나다순",
};

interface SortItemType {
  children: string;
  value: SortTypes;
}

export const sortItems: SortItemType[] = [
  {
    children: sortData["favorite"],
    value: SortTypes.favorite,
  },
  {
    children: sortData["asc"],
    value: SortTypes.asc,
  },
];

export const responsiveBreakpoint = [768, 1107];

export const vaccinationItems: VaccinationItemsType[] = [
  {
    children: "전체",
    value: VaccinationType.all,
  },
  {
    children: "백신 미접종",
    value: VaccinationType.unvaccinated,
  },
  {
    children: "화이자",
    value: VaccinationType.pfizer,
  },
  {
    children: "모더나",
    value: VaccinationType.moderna,
  },
  {
    children: "얀센",
    value: VaccinationType.janssen,
  },
  {
    children: "아스트라제네카",
    value: VaccinationType.az,
  },
];

export const vaccinationData = {
  all: "전체",
  unvaccinated: "백신 미접종",
  pfizer: "화이자",
  moderna: "모더나",
  janssen: "얀센",
  az: "아스트라제네카",
};

export const links = {
  travelInfo: {
    webview: (countryCode: string, linkType: LinkType) =>
      `mrt://${linkType}/${countryCode}`,
    web: (countryCode: string, linkType: LinkType) =>
      `https://www.myrealtrip.com/${linkType}?key_name=${countryCode}`,
  },
  airlineTicket: (
    type: "desktop" | "mobile" | "deeplink",
    airport: string
  ): string => {
    const link = {
      desktop: "https://flights.myrealtrip.com/air/b2c/AIR/INT/AIRINTTRP0100100000.k1?KSESID=air:b2c:SELK138RB:SELK138RB::00&depCtyCode1=SEL&arrCtyCode1=",
      mobile: "https://flights.myrealtrip.com/air/b2c/AIR/MBL/AIRMBLTRP0100100010.k1?KSESID=air:b2c:SELK138RB:SELK138RB::00&depCtyCode1=SEL&arrCtyCode1=",
      deeplink: "mrt://flights?url=https%3A%2F%2Fflights.myrealtrip.com%2Fair%2Fb2c%2FAIR%2FMBL%2FAIRMBLTRP0100100010.k1%3FKSESID%3Dair%3Ab2c%3ASELK138RB%3ASELK138RB%3A%3A00%26depCtyCode1%3DSEL%26arrCtyCode1%3D",
    };
    return link[type] + airport;
  },
};

export const snsListInfo = [
  {
    link: "https://www.facebook.com/myRealTrip",
    icon: {
      pc: "ic_facebook_24x24_gray_400",
      mo: "ic_facebook_20x20_gray_400",
    },
  },
  {
    link: "https://blog.naver.com/myrealtrip",
    icon: {
      pc: "ic_naver_24x24_gray_400",
      mo: "ic_naver_20x20_gray_400",
    },
  },
  {
    link: "https://www.instagram.com/myrealtrip/",
    icon: {
      pc: "ic_instagram_24x24_gray_400",
      mo: "ic_instagram_20x20_gray_400",
    },
  },
  {
    link: "https://www.youtube.com/channel/UC2oeFByIBQjkKXmQjE0U5rQ",
    icon: {
      pc: "ic_youtube_24x24_gray_400",
      mo: "ic_youtube_20x20_gray_400",
    },
  },
];

export const siteMapList = [
  {
    listName: "소개",
    list: [
      {
        itemName: "회사소개",
        link: "https://about.myrealtrip.com/",
      },
      {
        itemName: "채용",
        link: "https://career.myrealtrip.com/",
      },
      {
        itemName: "공고",
        link: "https://www.myrealtrip.com/announcement",
      },
    ],
  },
  {
    listName: "파트너",
    list: [
      {
        itemName: "파트너 등록하기",
        link: "https://www.myrealtrip.com/about/becomepartner",
      },
      {
        itemName: "Affiliate 프로그램",
        link: "https://www.myrealtrip.com/b2b",
      },
      {
        itemName: "리얼파트너",
        link: "https://www.myrealtrip.com/about/realguide",
      },
      {
        itemName: "파트너 블로그",
        link: "https://myrealtripkr.wordpress.com/",
      },
    ],
  },
  {
    listName: "지원",
    list: [
      {
        itemName: "자주 묻는 질문",
        link: "https://help.myrealtrip.com/hc/ko",
      },
      {
        itemName: "최저가 보장제",
        link: "https://www.myrealtrip.com/best_price",
      },
    ],
  },
];

export const policyList = [
  {
    itemName: "마이리얼트립 이용약관",
    link: "https://www.myrealtrip.com/terms/policy",
  },
  {
    itemName: "개인정보 처리방침",
    link: "https://www.myrealtrip.com/terms/privacy",
  },
  {
    itemName: "취소 및 환불 정책",
    link: "https://www.myrealtrip.com/terms/cancel",
  },
];
